<bz-button variant="tertiary" tone="primary" size="fit"
           appBringozIdGenerator="custom-select-filter-button"
           [ariaLabel]="placeholder() | translate"
           (clicked)="onOpenPanel($event)">
  <span class="layout-row layout-align-start-center filter-item">
    <bz-icon [icon]="icon()"></bz-icon>

    @if (selectedCount()) {
      @if (selectedLabel()) {
        <span class="margin-left-5 text-ellipsis selected-label">{{ selectedLabel() }}</span>
      } @else {
        <span class="margin-left-5">{{ countLabelKey() | translate: countLabelParams() }}</span>
      }
      <bz-icon class="pointer margin-left-5"
               appBringozIdGenerator="custom-select-filter-reset-button"
               [icon]="resetIcon"
               [label]="'Reset' | translate"
               (click)="onReset($event)">
      </bz-icon>
    } @else {
      <span class="margin-left-5">{{ placeholder() | translate }}</span>
    }
  </span>
</bz-button>
